import styled from 'styled-components';
import { HeadingStyle } from 'components/heading';
import { TextStyle } from 'components/text';
import { FontSize, FontWeight } from 'commons';

export const ContentWrapper = styled.div`
  width: 320px;
  height: 64dvh;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  padding: 12px 0;
  overflow: hidden;
`;

export const TextWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;

  ${TextStyle} {
    font-size: ${FontSize.font12};
  }

  ${HeadingStyle} {
    font-size: ${FontSize.font14};
    font-weight: ${FontWeight.bold};
  }
`;

export const FormWrapper = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Label = styled.label`
  font-size: ${FontSize.font10};
  color: ${({ theme }) => theme.neutral_500};
  strong {
    color: ${({ theme }) => theme.danger_300};
  }
`;

export const EmployeeList = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  overflow: auto;
  text-align: left;

  ${HeadingStyle} {
    align-self: flex-start;
  }
`;

export const EmployeeCard = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid ${({ theme }) => theme.neutral_300};
  border-radius: 8px;
  padding: 12px;
`;

export const EmployeeData = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 4px;
`;

export const DeleteEmployee = styled.div`
  button {
    color: ${({ theme }) => theme.danger_300};
    text-decoration: none;
    font-weight: ${FontWeight.bold};
    font-size: ${FontSize.font12};
  }
`;
